import type { BlockEditProps } from '@plone/types';
import TemplateSelectorBlock from '@plone-collective/volto-editortemplates/components/Blocks/TemplateSelectorBlock/TemplateSelectorBlock';
import { useIntl } from 'react-intl';
import { BlockDataForm, SidebarPortal } from '@plone/volto/components';
import { ViewBlock } from '@plone-collective/volto-editortemplates/components/Blocks/TemplateSelectorBlock/View';
import { BlockTemplatesProvider } from '../../Providers/block-template-editor';
import type {
  BlockTemplateData,
  TemplateData,
} from '@plone-collective/volto-editortemplates/types';

interface TemplateSelectorBlockEditProps extends BlockEditProps {
  data: BlockTemplateData<TemplateData>;
}

const EditBlock = (props: TemplateSelectorBlockEditProps) => {
  const intl = useIntl();
  const { selected, blocksConfig, onChangeBlock, block, data } = props;

  const schema = blocksConfig[data['@type']].blockSchema({
    data,
    intl,
  });
  return (
    <>
      <section>
        {!props.data.uid ? (
          <TemplateSelectorBlock
            onChangeBlock={onChangeBlock}
            block={block}
            data={data}
          />
        ) : (
          <ViewBlock {...props} isEditMode={true} />
        )}
      </section>
      {/* @ts-expect-error */}
      <SidebarPortal selected={selected}>
        <BlockDataForm
          {...props}
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => {
            onChangeBlock(block, {
              ...data,
              [id]: value,
            });
          }}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

const Edit = (props: TemplateSelectorBlockEditProps) => (
  <BlockTemplatesProvider isEditMode={!props.data.uid}>
    <EditBlock {...props} />
  </BlockTemplatesProvider>
);

export { Edit };
